import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e2608b70")

_pushScopeId("data-v-e2608b70")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"width":"200px","text-align":"center","margin":"auto"} }, [
  /*#__PURE__*/_createVNode("svg", {
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-029747aa": ""
  }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "#95bf47",
      d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"
    })
  ])
], -1)
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", null, "Thank you for business with us!", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Go to Dashboard ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_ctx.success)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goDashboard()))
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
})